import builder from '../builder';
import Share from '../../streamline-icons/bold/share.svg';

export default builder('IconShareBold', Share);
